import { $admin } from "@/utils/https.js";

// 完成订单
export function completeOrder(id) {
    return $admin().put(`/api/admin/manage/mall/handmade_order/${id}/complete`);
}

// 获取订单列表
export function getOrderList(params) {
    return $admin().get(`/api/admin/manage/mall/handmade_order`, { params });
}

// 备注订单
export function remarkOrder(id, data) {
    return $admin().put(`/api/admin/manage/mall/handmade_order/${id}/remark`, data);
}
